import {en, locales} from '@stripe-internal/cldr';

import type {RequiredLocaleData} from 'src/types';

export const DEFAULT_LOCALE = 'en-US' as const;

export const DEBUG_LOCALES = Object.freeze([
  'en-US-x-MESSAGE-ID',
  'en-US-x-STAR',
  'en-US-x-WIDE',
] as const);

export const SUPPORTED_LOCALES = Object.freeze([
  ...locales,
  ...DEBUG_LOCALES,
] as const);

export const DEFAULT_LOCALE_DATA: RequiredLocaleData = {
  locale: DEFAULT_LOCALE,
  messages: {},
  cldr: en.cldr,
  dateTimeStyles: en.dateTimeStyles,
};

export const DEFAULT_TIME_ZONE = ((): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return 'Etc/UTC';
  }
})();
